import { CSSProperties, FC, useCallback, useMemo } from 'react'

import { Flex, Tooltip, Typography } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';

import { Card } from '@hdi-seguros/web-components.card';

import { COLORS } from '../../../../../config/themes/colors';
import { BUTTON_COLOR, getColorsSectionGroupButton, getSectionGroupIcon, SectionGroupButtonColor } from '../../utils';

import './index.css';

export interface SectionGroupButtonProps {
    id:                     string;
    disabled?:              boolean;
    iconName:               JSX.Element;
    onPress?:               () => Promise<void> | void;
    subTitle:               string;
    title:                  string;
    isActive?:              boolean;
    color?:                 SectionGroupButtonColor;
    buttonContainerStyle?:  CSSProperties;
};

export const SectionGroupButton: FC<SectionGroupButtonProps> = ({ 
    title, 
    subTitle, 
    disabled,
    onPress,
    iconName,
    isActive = false,
    buttonContainerStyle = {},
    color = BUTTON_COLOR.DEFAULT,
}) => {
    const { iconColor, backgroundColor } = getColorsSectionGroupButton(color);

    const icon = getSectionGroupIcon(iconName, isActive || disabled ? COLORS.secondary[100] : iconColor);

    const onPressCard = useCallback(async () => {
        if(disabled) return;
        if(onPress) await onPress();
    }, [onPress, disabled]);

    const cardBrackgroundColor: string = useMemo(() => {
        if(disabled) return COLORS.neutrals[30]; 

        if(isActive) return COLORS.principal[15];

        return backgroundColor;
    }, [disabled, isActive, backgroundColor]);

    return (
        <Card
            className='container-section-group-button-card'
            style={{ 
                backgroundColor: cardBrackgroundColor, 
                cursor: disabled ? 'not-allowed' : 'pointer',
                opacity: disabled ? 0.5 : 1,
                ...buttonContainerStyle,
            }} 
            onClick={onPressCard}
        >
            <Flex align='center' justify='space-between' gap='small' className='w-100'>
                { icon }
    
                <Flex 
                    vertical 
                    className='container-title-section-group-button'
                > 
                    <Typography.Title level={5} className='title-section-group-button' >
                        { title.length > 42 ? title.substring(0, 42) : title }
                    </Typography.Title>

                    <Tooltip placement='bottom' title={subTitle}>
                        <Typography.Text>
                            { subTitle.length > 42 ? subTitle.substring(0, 42) : subTitle }
                        </Typography.Text>
                    </Tooltip>
                </Flex>    

                {
                    isActive && <CheckCircleFilled style={{ color: COLORS.secondary[100], fontSize: 30 }}  />
                } 
            </Flex>
        </Card>
    )
};